function toggleTabs (event) {
  let $this = event.target,
      id = $this.dataset.id;

  if (!$this.classList.contains("active")) {
    document.querySelector(".tab-item.active").classList.remove("active")

    document.querySelector(`.content.active`).classList.add("hidden")
    document.querySelector(`.content.active`).classList.remove("active")
    document.querySelector(`.content[data-id="${id}"]`).classList.add("active")
    document.querySelector(`.content[data-id="${id}"]`).classList.remove("hidden")
    $this.classList.add("active")

  }
}


const init = () => {
  document.querySelectorAll(".tab-item").forEach(item => {
    item.addEventListener("click", toggleTabs)
  })
}

export default init
